import { useState } from "react";
import { MembershipSignUp } from "./MembershipSignUp";

export const OpenMemberships = ({ series, federatedOrganisationTerm, defaultExpanded }) => {
    const openSeries = series.filter(series => series.signOnStatus === "open");
    const [expanded, setExpanded] = useState(defaultExpanded && openSeries.length === 1 ? { [openSeries[0].id]: true } : {});
    const openAccordionPanel = panel => (event, isExpanded) => setExpanded(panels => isExpanded ? { ...panels, [panel]: true } : { ...panels, [panel]: false });

    return openSeries.map(series =>
        <MembershipSignUp
            key={series.id}
            series={series}
            federatedOrganisationTerm={federatedOrganisationTerm}
            expanded={!!expanded[series.id]}
            openAccordionPanel={openAccordionPanel(series.id)}
        />
    );
};
